import React, { FunctionComponent, SVGProps } from 'react';

import styled from 'styled-components';

interface CopyIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

const CopyIcon: FunctionComponent<CopyIconProps> = ({
  className,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 16 16"
      width={16}
      height={16}
      className={className || ''}
      {...props}
    >
      <Circle d="M8,0h0c4.42,0,8,3.58,8,8h0c0,4.42-3.58,8-8,8h0C3.58,16,0,12.42,0,8H0C0,3.58,3.58,0,8,0Z" />
      <Path
        fillRule="evenodd"
        d="M10.74,9.98h-3.82c-.11,0-.22-.04-.3-.12-.08-.08-.12-.19-.13-.3V4.92c0-.06,.01-.11,.03-.16,.02-.05,.05-.1,.09-.14,.04-.04,.09-.07,.14-.09,.05-.02,.11-.03,.16-.03h3.82c.11,0,.22,.04,.3,.12,.08,.08,.12,.19,.12,.3v4.63c0,.11-.05,.22-.12,.3-.08,.08-.18,.12-.3,.12Zm-1.5,1.1c0,.06-.01,.11-.03,.16-.02,.05-.05,.1-.09,.14-.04,.04-.09,.07-.14,.09-.05,.02-.11,.03-.16,.03h-3.39c-.11,0-.22-.04-.3-.12-.08-.08-.12-.19-.12-.3V6.87c0-.11,.04-.22,.12-.3,.08-.08,.19-.12,.3-.12s.22,.04,.3,.12c.08,.08,.12,.19,.12,.3v3.59c0,.05,.02,.1,.06,.14,.04,.04,.09,.06,.14,.06h2.76c.11,0,.22,.05,.3,.12,.08,.08,.12,.18,.12,.3h0Z"
      />
    </svg>
  );
};

export default styled(CopyIcon)`
  opacity: 1;
  cursor: pointer;
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    opacity: 0.5;
  }
`;

const Circle = styled.path`
  fill: ${({ theme }) => theme.colors.box};
`;

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.primary};
`;
